import type { TEquipmentStatusPanelStore } from '../equipmentStatusPanelStore'

export const selectors = {
  getNodes: (s: TEquipmentStatusPanelStore) => s.nodes,
  getNodeLogs: (s: TEquipmentStatusPanelStore) => s.nodeLogs,
  getServiceIssues: (s: TEquipmentStatusPanelStore) => s.serviceIssues,
  getPropertyId: (s: TEquipmentStatusPanelStore) => s.propertyId,
  getFilters: (s: TEquipmentStatusPanelStore) => s.filters,
}
